import { PlatformType } from "@dp/common";
import { useStore } from "@dp/state";
export function useIsPlatformMobile() {
  var _store$platformUtil;

  var store = useStore();
  var platform = store === null || store === void 0 ? void 0 : (_store$platformUtil = store.platformUtil) === null || _store$platformUtil === void 0 ? void 0 : _store$platformUtil.PLATFORM_TYPE;
  var platformIsMobileApp = platform === PlatformType.APP ? true : false;
  return platformIsMobileApp;
}